import { reportTemplate } from '../../util.js';

export const execute = (node, context) => {
  return reportTemplate(node, [ 'label' ], 'Label', context);
};
